<template lang="pug">
	b-container(fluid)
		b-row(align-h="between" class="border")
			b-col(sm="auto" @click="m_goToMain()" style="cursor: pointer")
				img(alt="KBDP logo"  src="@/assets/logo-2.png" class="my-1" height="40")
		b-row(class="mt-4 ml-1 ")
			h5 ERROR... 
		b-row(class="ml-1 font-weight-lighter")
			span An error was encountered within the application or with the request.
		b-row(class="mt-2 ml-1")
			span(class="") Message:
			span(class="ml-1 text-danger") {{p_message || 'N/A'}}
		b-row(class="mt-4 ml-1 ")
			a(href="/") Reload Application
</template>

<script>


export default {
	name: "error",
	components: {},
	created() {
	},
	mounted() {},
	data() {
		return {
		};
	},
	props: {
		p_message: String
	},
	computed: {},
	methods: {},
}
</script>

<style lang="less">
</style>